module.exports = __webpack_public_path__ + "static/aox_burgerbeteiligung_wohnen_mini-17be6b0ff5632dfef6ba370881787d32.png";